module.exports = __webpack_public_path__ + "resource/static/img/icon11@1.5x.1678777.png";


//////////////////
// WEBPACK FOOTER
// ./static/img1/icon11@1.5x.png
// module id = 8Goj
// module chunks = 1